<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-btn @click="current>0?current--:''">-</v-btn>
      </v-col>
      <v-col cols="4">
        {{ current }}
      </v-col>
      <v-col cols="4">
        <v-btn @click="current<articles.length?current++:''">+</v-btn>
      </v-col>
      <v-col cols="12" v-html="articles[current].text.article" />
    </v-row>
  </v-container>
</template>

<script>
import articles from '@/assets/articles'

export default {
  data: () => {
    return {
      articles: articles,
      current: 0
    }
  }
}
</script>

<style>

</style>